'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { extractProps } from '../../utils/extract-props.js';
import { SideNavigationProvider, SyncPropWithSideNavigationStore, getSideNavigationInitializer, } from './side-navigation.store.js';
import { sideNavigationRootPropDefs } from './side-navigation.props.js';
const SideNavigationRoot = (props) => {
    const { children, defaultExpanded, expanded, onExpandedChange } = extractProps(props, sideNavigationRootPropDefs);
    const initializer = useState(() => getSideNavigationInitializer({
        initialExpanded: defaultExpanded ?? expanded,
    }))[0];
    return (_jsxs(SideNavigationProvider, { initializer: initializer, children: [_jsx(SyncPropWithSideNavigationStore, { name: "expanded", value: expanded, onChange: onExpandedChange }), children] }));
};
SideNavigationRoot.displayName = 'SideNavigation.Root';
export { SideNavigationRoot };
//# sourceMappingURL=side-navigation-root.js.map